/**
 * HM-484 cluster 18 Modulo 5 Cassa — client API.
 */
import { api } from './client.js';

export type CassaToday = {
  date: string;
  totals: {
    totalCents: number;
    cashCents: number;
    cardCents: number;
    extrasLiveCents: number;
    rsVoucherCents: number;
  };
  paymentsCount: number;
  zClosure: { id: string; zClosureId: string; createdAt: string } | null;
};

export type CassaMovement = {
  id: string;
  createdAt: string;
  method: 'cash' | 'card' | 'card_online' | 'voucher';
  amount: string;
  status: string;
  bookingId: string | null;
  publicCode: string | null;
  roomCode: string | null;
};

export async function getCassaToday(date?: string): Promise<CassaToday> {
  const qs = date ? `?date=${date}` : '';
  return api(`/cassa/today${qs}`);
}

export async function getCassaMovements(
  date?: string,
): Promise<{ date: string; movements: CassaMovement[] }> {
  const qs = date ? `?date=${date}` : '';
  return api(`/cassa/movements${qs}`);
}

export async function postZClose(): Promise<{
  ok: boolean;
  zClosureNumber: string;
  totalsCents: number;
  printedAt: string;
}> {
  return api('/cassa/z-close', { method: 'POST' });
}
